import React, { forwardRef } from 'react';

import MUIDialogContentText, {
  DialogContentTextProps as MUIDialogContentTextProps,
} from '@material-ui/core/DialogContentText';

interface DialogCOntentTextProps extends MUIDialogContentTextProps {}

const DialogContentText = forwardRef<HTMLDivElement, DialogCOntentTextProps>(
  (props, ref) => {
    return (
      <MUIDialogContentText {...props} ref={ref}>
        {props.children}
      </MUIDialogContentText>
    );
  }
);

DialogContentText.displayName = 'DialogContentText';

export default DialogContentText;
